import React, { FC } from 'react';

import { Icon } from '@iconify/react';
import { IconButton, Tooltip } from '@mui/material';

import { useThemeMode } from '~/contexts/ThemeModeContext';
import analytics from '~/services/analytics';

const ThemeToggle: FC = () => {
  const { themeMode, toggleTheme } = useThemeMode();
  const isDark = themeMode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        onClick={() => {
          analytics.trackEvent('navigation - light_dark mode switch', {
            theme: isDark ? 'light' : 'dark',
          });
          toggleTheme();
        }}
        sx={{
          color: 'common.black',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Icon
          icon={isDark ? 'ph:sun-bold' : 'ph:moon-bold'}
          width={20}
          height={20}
        />
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
